import React, { useState } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { signIn } from "next-auth/react";
import AuthLayout, {
  authButtonClass,
  authFieldClass,
} from "@/components/AuthLayout";

export default function LoginPage() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await signIn("credentials", {
      email,
      password,
      redirect: false,
    });
    setBusy(false);
    if (res?.error) {
      setError("Incorrect email or password.");
      return;
    }
    router.push((router.query.callbackUrl as string) || "/");
  };

  return (
    <AuthLayout title="Sign in">
      <h2 className="text-2xl font-bold tracking-tight text-slate-900">
        Welcome back
      </h2>
      <p className="mt-1.5 text-[14px] text-slate-500">
        Sign in to your workspace.
      </p>

      <form onSubmit={submit} className="mt-8 space-y-4">
        <div>
          <label className="mb-1.5 block text-[13px] font-medium text-slate-700">
            Email
          </label>
          <input
            type="email"
            required
            autoFocus
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            className={authFieldClass}
          />
        </div>
        <div>
          <label className="mb-1.5 block text-[13px] font-medium text-slate-700">
            Password
          </label>
          <input
            type="password"
            required
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••••••"
            className={authFieldClass}
          />
        </div>

        {error && (
          <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-[13px] text-red-600">
            {error}
          </div>
        )}

        <button type="submit" disabled={busy} className={authButtonClass}>
          {busy ? "Signing in..." : "Sign in"}
        </button>

        <p className="text-center">
          <Link
            href="/forgot"
            className="text-[13px] font-medium text-slate-400 hover:text-indigo-600"
          >
            Forgot your password?
          </Link>
        </p>
      </form>

      <p className="mt-6 text-center text-[13px] text-slate-500">
        New here?{" "}
        <Link
          href="/signup"
          className="font-semibold text-indigo-600 hover:text-indigo-700"
        >
          Create an account
        </Link>
      </p>
    </AuthLayout>
  );
}
